
































import Header from '@/components/Header.vue';
import { getTemplatesByCategory } from '@/helpers/template';
import { Category } from '@/types/Category';
import { Template } from '@/types/Template';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Category',
    components: { Header },
    computed: {
        ...mapGetters(['categories', 'templates']),
        category(): Category | undefined {
            return this.categories.find((category: Category) => category.id.toString() === this.$route.params.id);
        },
        availableTemplates(): Template[] {
            return this.category ? getTemplatesByCategory(this.templates, this.category) : [];
        },
    },
    methods: {
        async createVideo(template: Template) {
            const video = await this.$store.dispatch('createVideo', { template });

            await this.$router.push(`/projects/${video.id}`);
        },
    },
});
